module.exports = __webpack_public_path__ + "static/img/12.b4be95a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/12.png
// module id = Ih9O
// module chunks = 0